import { createSelector } from 'reselect';
import qs from 'qs';

export const selectQueryParams = (state) => state.queryParams;

/* istanbul ignore next */
export const selectQueryString = createSelector([selectQueryParams], (queryParams) =>
    qs.stringify(queryParams)
);

/* istanbul ignore next */
export const selectDecodedQueryString = createSelector([selectQueryString], (queryString) =>
    decodeURIComponent(queryString)
);
